// src/pages/salas/SalasLogin.jsx — login del módulo de salas de juntas.
// Mismas credenciales que CaprepaDesk (POST /auth/login); al entrar manda a
// /salas (o a donde venía, p. ej. /salas?sala=sala-2 desde el QR de una sala).
import React, { useContext, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import { AuthContext } from '../../context/AuthContext';
import api from '../../services/api';
import AuthShell, { IconEye, IconArrow } from '../../components/auth/AuthShell';

export default function SalasLogin() {
    const { token, login } = useContext(AuthContext);
    const location = useLocation();
    const dest = location.state?.from && String(location.state.from).startsWith('/salas') ? location.state.from : '/salas';
    const [identifier, setIdentifier] = useState('');
    const [password, setPassword] = useState('');
    const [showPass, setShowPass] = useState(false);
    const [loading, setLoading] = useState(false);

    if (token) return <Navigate to={dest} replace />;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await api.post('/auth/login', { identifier: identifier.trim(), password });
            login(res.data.token, dest);
        } catch (err) {
            toast.error(err.response?.data?.error || 'Credenciales inválidas', { autoClose: 3000 });
        } finally { setLoading(false); }
    };

    return (
        <AuthShell eyebrow="Salas de juntas">
            <h1 className="auth-title">Reservar sala</h1>
            <p className="auth-subtitle">Entra con tu usuario de CaprepaDesk (el mismo del intranet).</p>
            <form onSubmit={handleSubmit}>
                <div className="auth-field">
                    <div className="auth-field-header"><label className="auth-label" htmlFor="sl-id">Usuario o correo</label></div>
                    <input id="sl-id" type="text" className="auth-input" value={identifier} onChange={e => setIdentifier(e.target.value)}
                           placeholder="usuario" required autoFocus autoComplete="username" />
                </div>
                <div className="auth-field">
                    <div className="auth-field-header"><label className="auth-label" htmlFor="sl-pw">Contraseña</label></div>
                    <div className="auth-input-wrap">
                        <input id="sl-pw" type={showPass ? 'text' : 'password'} className="auth-input has-toggle" value={password}
                               onChange={e => setPassword(e.target.value)} placeholder="Tu contraseña" required autoComplete="current-password" />
                        <button type="button" className="auth-toggle" onClick={() => setShowPass(v => !v)} tabIndex={-1}
                                aria-label={showPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}><IconEye off={showPass} /></button>
                    </div>
                </div>
                <button type="submit" className="auth-submit" disabled={loading}>
                    {loading ? <Spinner size="sm" animation="border" /> : <>Entrar <IconArrow /></>}
                </button>
            </form>
            <div className="auth-footer-link">
                Las salas se reservan desde nivel líder, gerente, subdirector o director. Si no tienes acceso, recepción puede reservar por ti.
            </div>
        </AuthShell>
    );
}
